/**
 * MODULE: _shared/frontend-shell/src/pages/LegacyModuleRedirect.tsx
 * PURPOSE: Send legacy module URLs into the Agentic conversation or record workspace
 * DEPENDENCIES: react-router-dom, agenticWorkspaceUrl
 * PUBLIC_API: LegacyModuleRedirect (default)
 * SIDE_EFFECTS: window.location.replace to /agent (localhost :5174, hosted same origin)
 * AGENT SAFETY: 🟡 RESTRICTED
 * FILE_SIZE: ~32 / 200 lines
 * RECENT: 2026-10-09 [2.2.2168] — CRM records keep their id; other modules open /agent.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { agentPathForLegacyModule, redirectToAgentPath } from '../lib/agenticWorkspaceUrl';

export default function LegacyModuleRedirect() {
  const { pathname } = useLocation();

  useEffect(() => {
    redirectToAgentPath(agentPathForLegacyModule(pathname));
  }, [pathname]);

  return (
    <p className="p-6 text-sm text-gray-600 dark:text-gray-300" data-testid="legacy-module-redirect">
      Opening Brazn…
    </p>
  );
}
